//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import loadmore from '@/components/ui/loadmore';
import dialogbox from '@/components/ui/dialogbox';
import inputbox from '@/components/ui/inputbox';
import mainMenuTab from "@/components/mainMenuTab";
import buttonbox from '@/components/ui/buttonbox';

export default {
    components: {mainMenuTab,cardbox,navbar,loadmore,dialogbox,inputbox,buttonbox},
    data(){
        return {
            listData: {
                current_page: 1,
                total: 0,
                per_page: 50,
                data: [],
            },
            addData: {
                title: '反馈您的诉求',
                show: false,
                style: 'height:18rem;',
            },
            submitInfo: {
                content: '',
            }
        }
    },
    filters: {
        timer: function(value){
            if(!value) return '';
            let date = new Date(value);
            return common.formatDate(date,'ymd');
        }
    },
    methods:{

        // 打开地址操作面板
        openFeedback(){
            this.submitInfo.content= '';
            this.addData.show = true;
        },

        // 新增地址
        addFeedback(){

            const info = this.submitInfo;

            if(info.content.length < 2){
                this.$vux.toast.text('反馈信息不能为空');
                return false;
            }


            const opts = {
                url: api.myFeedbackAdd,
                data: {
                    ...info
                },
                type: 'post'
            }

            common.query(opts).then(res=>{
                this.addData.show = false;
                this.queryFeedback();
            },res=>{
                this.$vux.toast.text(res.message)
            })

        },

        // 查询列表
        queryFeedback(){

            const opts = {
                url: api.myFeedback,
                data: {},
                type: 'get'
            }
            common.query(opts).then(res=>{
                this.listData = res.data;
            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){

        this.queryFeedback();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/feedback.vue